import { Chasity, Danielle, Fred, Larissa, Nick } from "../Assets/Images";
import { CheckCircleWithShadow, CloseWithShadow } from "../Assets/Icons";

import { formatCurrency, formatDate } from "./helpers";

export const mediumScreenStartFrom = 629;

export const reviewersData = [
  {
    profileImageLink: Danielle,
    profileImageName: "danielle",
    userFullName: "Danielle Hunter",
    userStatus: "$1,358 total cash back earned",
    reviewString:
      "Being able to earn cash back on making on-time rental payments is a huge plus! It helps to keep money in your pocket or being able to allocate those savings to other bills.",
    rating: 4.9,
  },
  {
    profileImageLink: Chasity,
    profileImageName: "chasity",
    userFullName: "Chasity English",
    userStatus: "$981 total cash back earned",
    reviewString:
      "TThis app is really easy to use no hassle and it helps me keep up with my rent being on time! The extra money I get back helps me a lot to as well.",
    rating: 4.7,
  },
  {
    profileImageLink: Nick,
    profileImageName: "nick",
    userFullName: "Nick Henderson",
    userStatus: "$1,095 total cash back earned",
    reviewString:
      "After paying your rent on time you get a reward and it eases the pressure of making it until payday. I wish this had been available at all the other properties I have rented at.",
    rating: 4.8,
  },
  {
    profileImageLink: Fred,
    profileImageName: "fred",
    userFullName: "Fred Bailey",
    userStatus: "$704 total cash back earned",
    reviewString:
      "Stake is a great incentive tool used to get residents to pay rent on time and get rewarded for doing so! Stake helped me out in times I needed the extra funds to pay bills or get food.",
    rating: 4.7,
  },
  {
    profileImageLink: Larissa,
    profileImageName: "larissa",
    userFullName: "Larissa Smith",
    userStatus: "$1,108 total cash back earned",
    reviewString:
      "Love this app! It helps me stay on top of my payments and makes me want to pay early every month just to save, whoever thought of this was genius, I love how it tracks it and it also tells me how much I would save if I pay on a certain day.",
    rating: 4.9,
  },
];

export const phoneNumberMask = "(000) 000-0000";
export const phoneNumberMask9Digit = "(000) 000-000";
export const ssnMask = "000 00 0000";

export const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const ToastVariants = ["success", "error", "warning", "info"];

export const SuccessToastVariant = ToastVariants[0];
export const ErrorToastVariant = ToastVariants[1];
export const WarningToastVariant = ToastVariants[2];
export const InfoToastVariant = ToastVariants[3];

export const modalVariants = {
  tooltipDialog: "tooltip-dialog",
  infoDialog: "info-dialog",
  stepByStepDialog: "step-by-step-dialog",
  formDialog: "form-dialog",
  statusDialog: "status-dialog",
  promptDialog: "prompt-dialog",
  flexDialog: "flex-dialog",
  fullScreenDialog: "fullscreen-dialog",
};

export const appUtilityKeys = {
  authKey: "auth_key",
  loggedInUserData: "user",
  userSfid: "user_sfid",
  transferToken: "transfer_token",
  astraToken: "astra_token",
  astraRefreshToken: "astra_refresh_token",
  astraIntentId: "astra_intent_id",
  lastAstraTokenFetchTime: "last_astra_token_fetch_time",
  stakePay3AuthToken: "stakepay_3_auth_token",
  deeplink: "deeplink",
  agentId: "agentId",
  hasVisitedWelcomeScreen: (userId) => `hasVisitedWelcomeScreen-${userId}`,
  animateAvailableBalanceFrom: (userId) => `animateAvailableBalanceFrom-${userId}`,
};

export const isDevNodeEnv = process.env.NODE_ENV === "development";
export const isDevReactEnv = process.env.REACT_APP_ENV === "development";

export const debugProps = isDevReactEnv ? { debug: true } : {};

export const neglectEndpointsForUnauthorisedErrors = [
  "/mobile/loginRequestSms",
  "/mobile/loginSms",
  "/mobile/emailChangeRequestVerification",
  "/mobile/emailChangeVerification",
  "/mobile/phoneNumberChangeRequestSms",
  "/mobile/phoneNumberChangeSms",
  "/create_astra_account",
  "/mobile/stake_payroll/",
  "/mobile/stake_payroll/get_link_token/",
];

export const APIQueryKeys = {
  mobileAppSummary: ["mobile-app-summary"],
  platformSummaryStats: ["platform-summary-stats"],
  deals: ["deals"],
  consumerDeals: ["consumer-deals"],
  rentDetails: ["rent-details"],
  unclaimedTransactions: ["unclaimed-transactions"],
  transferToken: ["transfer_token"],
  alternativeLoginFlag: ["alternative-login-flag"],
  connectedAccounts: ["connected-accounts"],
  connectedAccountsSelection: ["connected-account-selection"],
  stakeDebit: ["stake-debit"],
  stakeDebitStatements: ["stake-debit-statements"],
  payrollAccount: ["payroll-account"],
  creditReporting: ["credit-reporting"],
  paymentHistories: ["payment-histories"],
  transactionList: ["transaction-list"],
  userAccount: ["user-account"],
  activities: ["activities"],
  sendVerificationCodeUsingUniqueID: ["send-verification-code-using-unique-id"],
  customerTokenVerificationSMS: ["customer-token-verification-sms"],
  astraCards: ["astra-cards"],
  astraAccounts: ["astra-accounts"],
  routesCapabilities: ["astra-routes-capabilities"],
  recurringDeposit: ["recurring-deposit"],
  stakePay3Auth: ["stakepay-3-auth"],
  stakePay3PaymentDetails: ["stakepay-3-payment-details"],
  finixPublicKey: ["finix-public-key"],
  stripePublicKey: ["stripe-public-key"],
  finixConnectedCards: ["finix-connected-cards"],
  stakePay3PaymentMonths: ["stakepay-3-payment-months"],
  stakePay3PaymentSetupSummary: ["stakepay-3-payment-setup-summary"],
  stakePay3AutopayPaymentSetupSummary: ["stakepay-3-autopay-payment-setup-summary"],
  stakePay3PaymentDetailsForSelectedMonth: ["stakepay-3-payment-details-for-selected-month"],
  stakePay3PastPayments: ["stakepay-3-past-payments"],
  consumerPaymentMethods: ["consumer-payment-methods"],
  isCustomerFromPartnerOnboarded: ["is-customer-from-partner-onboarded"],
  getPartnerCustomerInformation: ["get-partner-customer-information"],
  onPartnerOnboardingLoad: ["on-partner-onboarding-load"],
  fidelPublicKey: ['fidel-public-key'],
  fidelLinkData: ['fidel-link-data'],
  fidelCards: ['fidel-cards'],
  fidelNearestLocations: ['fidel-nearest-locations'],
  stakeSaverFormPrefill: ["stake-saver-form-prefill"],
  applyingStakeSaverDiscount: ["applying-stake-saver-discount"],
  payeeList: ["payee-list"],
  rentPayments: ["rent-payments"],
  recurringRentPayments: ["recurring-rent-payments"],
  customerInsuranceDetails: ["customer-insurance-details"],
  insurancePolicyDetails: ["insurance-policy-details"],
  myUtilitiesOrderDetail: ["my-utilities-order-detail"],
  renterPrograms: ["renter-programs"],
  appEssentials: ["app-essentials"],
  bankingLimits: ["banking-limits"],
};

export const longMonthDateFormat = { year: "numeric", month: "long", day: "numeric" };
export const numericDateFormat = { year: "numeric", month: "numeric", day: "numeric" };
export const nilYearLongMonthDateFormat = { year: undefined, month: "long", day: "numeric" };
export const nilDayLongMonthDateFormat = { year: "numeric", month: "long", day: undefined };
export const shortDateTimeFormat = { timeStyle: "short", dateStyle: "short" };
export const fullMonthFormat = { month: "long" };

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const weekdayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const SuccessfulTransferStatusModalProps = {
  StatusIcon: CheckCircleWithShadow,
  title: "Your transfer was initiated!",
  CTAButtonText: "Done",
};

export const FailedTransferStatusModalProps = {
  StatusIcon: CloseWithShadow,
  statusClassName: "error",
  title: "We're having trouble completing your transfer.",
  description: "Try again in a few minutes. Contact Stake if the problem persists.",
  CTAButtonText: "Done",
};

export const SuccessfulRecurringDepositStatusModalProps = {
  StatusIcon: CheckCircleWithShadow,
  title: "Deposit Scheduled!",
  CTAButtonText: "View Summary",
  secondaryCTAButtonText: "Go to Banking",
};

export const FailedRecurringDepositStatusModalProps = {
  StatusIcon: CloseWithShadow,
  statusClassName: "error",
  title: "Sorry, there was an issue with your recurring deposit",
  description:
    "Please try again in a few minutes. If the problem persists, contact Stake's support team for assistance.",
  CTAButtonText: "Try Again",
  secondaryCTAButtonText: "Cancel",
};

export const SuccessfulRentPaymentStatusModalProps = {
  StatusIcon: CheckCircleWithShadow,
  title: "Rent Payment Scheduled",
  CTAButtonText: "Done",
};

export const SuccessfulRentPaymentStatusAutoPayEligibleModalProps = {
  CTAButtonText: "Set up Autopay",
  secondaryCTAButtonText: "Maybe Later",
};

export const SuccessfulRentPaymentStatusDescription = ({ isAutopayEligible, amount, date }) =>
  `Your rent payment of ${formatCurrency(amount)} is scheduled for ${formatDate(date, nilYearLongMonthDateFormat)}.${
    isAutopayEligible
      ? "\nWant to make future payments easier? Set up autopay to pay rent automatically every month and avoid late fees."
      : " A confirmation will be sent once the payment is processed successfully."
  }`;

export const FailedRentPaymentStatusModalProps = {
  StatusIcon: CloseWithShadow,
  statusClassName: "error",
  title: "Rent payment failed",
  CTAButtonText: "Retry Payment",
  secondaryCTAButtonText: "Cancel",
};

export const FailedRentPaymentStatusDescription = (isAutopay) =>
  `${
    isAutopay ? "We encountered an issue while processing" : "We couldn't schedule"
  } your rent payment. Please check your payment method or try again.`;

export const LateRentPayemtStatusModalProps = {
  title: "Confirm Late Payment",
  description:
    "You are scheduling your rent payment for a date that is not eligible for any Cash Back and is subject to additional fees",
  CTAButtonText: "Proceed",
  secondaryCTAButtonText: "Cancel",
};

export const ConfirmTurnOffAutopayModalProps = {
  variant: "alert-neutral",
  title: "Turn off Autopay?",
  description:
    "By turning off autopay, you'll need to remember to pay rent manually each month. However, you can still schedule the payment for the upcoming month's rent.",
  CTAButtonText: "Confirm",
  secondaryCTAButtonText: "Cancel",
};

export const SuccessClearRecurringDepositStatusModalProps = {
  StatusIcon: CheckCircleWithShadow,
  title: "Recurring Deposit Removed Successfully",
  description:
    "Your existing recurring deposit has been successfully removed. If you wish to set up a new deposit, you can do so at any time.",
  CTAButtonText: "Done",
};

export const ClearRecurringDepositFailureStatusModalProps = {
  StatusIcon: CloseWithShadow,
  statusClassName: "error",
  title: "Error Removing Recurring Deposit",
  description:
    "Unfortunately, there was an issue removing your recurring deposit. Please try again in a few minutes. If the problem persists, contact Stake’s support team for assistance.",
  CTAButtonText: "Try Again",
  secondaryCTAButtonText: "Cancel",
};

export const EditAutopayRentWarningModalProps = {
  StatusIcon: CloseWithShadow,
  variant: "alert-neutral",
  title: "Edit Autopay?",
  description:
    "Editing Autopay will reset all scheduled monthly payments, including any customized payments, and apply the new settings to all future payments.",
  CTAButtonText: "Proceed",
  secondaryCTAButtonText: "Cancel",
};

export const EarnCashbackWithStakeCheckingModalProps = (paymentMethod) => ({
  StatusIcon: CloseWithShadow,
  variant: "alert-neutral",
  title: `Pay with ${paymentMethod === "card" ? "debit or credit card" : "Checking Account/ACH"}?`,
  description: `Earn more Cash Back by using Stake Checking instead of your ${
    paymentMethod === "card" ? "debit or credit card" : "Checking Account/ACH"
  }.`,
  CTAButtonText: "Continue",
  secondaryCTAButtonText: "Cancel",
});

export const CancelStakeSaverDealModalProps = {
  title: "Are you sure you want to cancel the Stake Saver Deal?",
  description: (
    <>
      By canceling Stake Saver, you will no longer be eligible for Stake's Credit Builder product and will be subject to
      Stake's minimum balance fee.<br></br>Note: Canceling Stake Saver does not close your Stake Checking account. To
      close your account, please contact our Customer Support team. See our{" "}
      <a
        className="color--primary-400"
        href="https://www.stakerent.com/legal/end-user-terms"
        target="_blank"
        rel="noreferrer"
      >
        Terms & Conditions
      </a>{" "}
      and{" "}
      <a className="color--primary-400" href="https://www.stakerent.com/disclosure" target="_blank" rel="noreferrer">
        Disclosures
      </a>{" "}
      for more details.
    </>
  ),
  CTAButtonText: "Confirm",
  secondaryCTAButtonText: "Cancel",
};

export const UpdateDealPaymentModalProps = {
  title: "Update Your Payment Method",
  CTAButtonText: "Update",
  secondaryCTAButtonText: "Cancel",
};

export const astraActionTypeCollectAuthorization = "COLLECT_AUTHORIZATION";
export const astraActionTypeLinkCard = "LINK_CARD";

export const finixFormConfig = {
  showAddress: true,
  labels: {
    name: "Cardholder Name",
    expiration_date: "Expiry Date",
    security_code: "CVV / CVC",
    address_postal_code: "Zip / Postal code",
  },
  placeholders: {
    name: "Full name on card",
    number: "0000-0000-0000-0000",
    expiration_date: "MM / YY",
    address_postal_code: "12345",
  },
  hideFields: ["address_line1", "address_line2", "address_city", "address_state", "address_region"],
  requiredFields: ["address_country", "address_postal_code"],
  styles: {
    default: {
      color: "#f4fdfa",
      backgroundColor: "#171b26",
      border: "1px solid rgb(from #f4fdfa r g b / 30%)",
      borderRadius: "6px",
      padding: "12px",
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      height: "48px",
    },
    error: {
      border: "1px solid #F14242",
    },
  },
  fonts: [
    {
      fontFamily: "Poppins",
      url: "https://cdn.jsdelivr.net/fontsource/fonts/poppins@latest/latin-500-normal.woff2",
      format: "woff2",
    },
  ],
};

export const contactStakeIfErrorPersistsMessage = (
  <>
    {"Something went wrong. Please reload the page. If the error persists, contact "}
    <a href="mailto:hello@stake.rent">hello@stake.rent</a>
  </>
);

export const USStates = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "American Samoa", value: "AS" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Guam", value: "GU" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Northern Mariana Islands", value: "MP" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Trust Territories", value: "TT" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Virgin Islands", value: "VI" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const UnitOccupationList = [
  { label: "Architect Or Engineer", value: "ArchitectOrEngineer" },
  { label: "Business Analyst Accountant Or Financial Advisor", value: "BusinessAnalystAccountantOrFinancialAdvisor" },
  { label: "Community And Social Services Worker", value: "CommunityAndSocialServicesWorker" },
  { label: "Construction Mechanic Or Maintenance Worker", value: "ConstructionMechanicOrMaintenanceWorker" },
  { label: "Doctor", value: "Doctor" },
  { label: "Educator", value: "Educator" },
  { label: "Entertainment Sports Arts Or Media", value: "EntertainmentSportsArtsOrMedia" },
  { label: "Executive Or Manager", value: "ExecutiveOrManager" },
  { label: "Farmer Fisherman Forester", value: "FarmerFishermanForester" },
  { label: "Food Service Worker", value: "FoodServiceWorker" },
  { label: "Gig Worker", value: "GigWorker" },
  {
    label: "Hospitality Office Or Administrative Support Worker",
    value: "HospitalityOfficeOrAdministrativeSupportWorker",
  },
  { label: "Household Manager", value: "HouseholdManager" },
  { label: "Janitor Housekeeper Landscaper", value: "JanitorHousekeeperLandscaper" },
  { label: "Lawyer", value: "Lawyer" },
  { label: "Manufacturing Or Production Worker", value: "ManufacturingOrProductionWorker" },
  { label: "Military Or Public Safety", value: "MilitaryOrPublicSafety" },
  { label: "Nurse Healthcare Technician Or Healthcare Support", value: "NurseHealthcareTechnicianOrHealthcareSupport" },
  { label: "Personal Care Or Service Worker", value: "PersonalCareOrServiceWorker" },
  { label: "Pilot Driver Operator", value: "PilotDriverOperator" },
  { label: "Sales Representative Broker Agent", value: "SalesRepresentativeBrokerAgent" },
  { label: "Scientist Or Technologist", value: "ScientistOrTechnologist" },
  { label: "Student", value: "Student" },
];

const fidelInputStyle = {
  style: {
    color: "#f4fdfa",
    border: "none",
    background: "#171b26",
  },
  errorStyle: {
    border: "2px solid #f14242",
  },
};

const fidelLabelStyle = {
  style: {
    color: "#f4fdfa",
  },
};

export const fidelCustomStyles = {
  close: {
    location: "form",
    color: "#f4fdfa",
  },
  overlay: {
    style: {
      background:
        "linear-gradient(0deg, rgba(33, 37, 41, 0.32) 0%, rgba(33, 37, 41, 0.32) 100%), rgba(33, 39, 55, 0.50)",
      backdropFilter: "blur(15px)",
    },
  },
  form: {
    style: {
      backgroundColor: "#212737",
      border: "1px solid rgba(244, 253, 250, 0.20)",
    },
  },
  title: {
    style: {
      textAlign: "center",
      color: "#f4fdfa",
    },
  },
  cardNumber: {
    label: fidelLabelStyle,
    input: fidelInputStyle,
  },
  expiryDate: {
    label: fidelLabelStyle,
    input: fidelInputStyle,
  },
  country: {
    label: fidelLabelStyle,
    input: fidelInputStyle,
  },
  submit: {
    style: {
      background: "#54ff99",
      color: "#212737",
      borderRadius: "6px",
    },
  },
  terms: {
    urlStyle: {
      color: "#54ff99",
    },
    style: {
      color: "#f4fdfa",
    },
    checkbox: {
      style: { borderRadius: "3px", border: "1px solid rgba(244, 253, 250, 0.20)" },
      checkedStyle: { background: "#54ff99", border: "none" },
      checkColor: "#212737",
    },
  },
};
